'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of fs account mobile
 */ const FsAccountMobile = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.3984",
                y: "68.6973",
                width: "17.4267",
                height: "5.17625",
                rx: "2.33602",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.909 19H63.1865C64.8049 19.009 66.3542 19.6569 67.497 20.8028C68.6398 21.9486 69.2836 23.4996 69.288 25.1178V78.4869C69.2836 80.1081 68.6375 81.6615 67.491 82.8079C66.3445 83.9542 64.7908 84.6002 63.1695 84.6047H40.892C39.2706 84.6002 37.717 83.9542 36.5705 82.8079C35.424 81.6615 34.7779 80.1081 34.7734 78.4869V66.7484V59.1935V57.3381V25.1178C34.7779 23.4937 35.4263 21.9376 36.5765 20.7908C37.7266 19.644 39.2847 19 40.909 19Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.6015 68.7773H45.4891C44.0928 68.7773 42.9609 69.9091 42.9609 71.3052C42.9609 72.7013 44.0928 73.833 45.4891 73.833H58.6015C59.9978 73.833 61.1296 72.7013 61.1296 71.3052C61.1296 69.9091 59.9978 68.7773 58.6015 68.7773Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "49.1445",
                y: "73.834",
                width: "5.98901",
                height: "5.85592",
                rx: "2.92796",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "37.4336",
                y: "21.9277",
                width: "29.4127",
                height: "48.4444",
                rx: "2.86482",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3427_24161)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M58.0184 42.6884C58.0184 42.6884 58.0184 42.7105 58.0184 42.7326C58.0184 42.9095 57.7479 46.6244 53.0817 48.305V45.9831L55.8995 42.9758C56.1474 42.7105 56.1474 42.2904 55.8544 42.025C55.5839 41.7818 55.1556 41.7818 54.8851 42.0692L53.0817 44.0151V42.025C53.0817 42.025 53.0817 42.025 53.0817 42.0029C53.3071 41.4943 54.3891 39.5042 57.0491 39.5042C57.0717 39.5042 57.0942 39.5042 57.1167 39.5042C58.1762 40.7425 58.0184 42.6663 58.0184 42.6884ZM51.7292 44.0151L49.9033 42.0692C49.6553 41.8039 49.227 41.7818 48.9565 42.025C48.686 42.2683 48.6634 42.7105 48.9114 42.9758L51.7292 45.9831V48.2828C47.063 46.6023 46.815 42.8653 46.7925 42.7105C46.7925 42.6884 46.7925 42.6884 46.7925 42.6663C46.7925 42.6442 46.6121 40.7204 47.6716 39.4821C47.6941 39.4821 47.7167 39.4821 47.7618 39.4821C50.4443 39.4821 51.5038 41.4943 51.7292 41.9808C51.7292 41.9808 51.7292 41.9808 51.7292 42.0029V44.0151ZM57.9283 38.3543C57.8155 38.2438 57.6577 38.1774 57.5 38.1553C54.9527 38.0005 53.2846 39.2831 52.4054 40.4771C51.5263 39.2831 49.8807 38.0005 47.3109 38.1553C47.1531 38.1553 46.9953 38.2438 46.8826 38.3543C45.2371 39.9686 45.4174 42.5336 45.4399 42.7768C45.4399 42.9537 45.5526 44.2141 46.3867 45.6736C47.1757 47.0667 48.8438 48.902 52.1575 49.8307C52.18 49.8307 52.2026 49.8307 52.2026 49.8528C52.2251 49.8528 52.2251 49.8528 52.2476 49.8528C52.2702 49.8528 52.2702 49.8528 52.2927 49.8528C52.3153 49.8528 52.3604 49.8528 52.3829 49.8528C52.4054 49.8528 52.4505 49.8528 52.4731 49.8528C52.4956 49.8528 52.4956 49.8528 52.5181 49.8528C52.5407 49.8528 52.5407 49.8528 52.5632 49.8528C52.5858 49.8528 52.6083 49.8528 52.6309 49.8307C58.7849 48.1281 59.3259 43.2633 59.3484 42.799C59.3709 42.6663 59.5964 40.0128 57.9283 38.3543Z",
                    fill: theme.ds5.asset.grey["700"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_24161",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "14.2015",
                        height: "11.9407",
                        fill: "white",
                        transform: "translate(45.3047 38.0449)"
                    })
                })
            })
        ]
    });
};

exports.FsAccountMobile = FsAccountMobile;
//# sourceMappingURL=FsAccountMobile.cjs.map
